import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutAppointmentStatusQuickInfo } from "./autogen/AutogenLayoutAppointmentStatusQuickInfo";

export class AppointmentStatusQuickInfo extends AutogenLayoutAppointmentStatusQuickInfo {

    sourceAppointmentStatusAfterExecution(event: DataSourceExecutionEvent) {
        const row = event.data;
        this.panelColorDisplay.backgroundColor = row?.get("status_hex_color");
        this.panelColorDisplay.tooltip = row?.get("status_hex_color");
        const link = LayoutUrl.createForUpdateMode("lme/dispatch/AppointmentStatus", row?.get("id"));
        this.textboxId.printableLabel.link = link;
    }
}
